import { ObjectivesViewEnum } from '../objectives.constants';
import { useGetAllObjectives } from './useGetAllObjectives';
import { useGetCategoryEligibility } from './useGetCategoryEligibility';
import { useGetReporteeObjectives } from './useGetReporteeObjectives';

export const useObjectivesForView = (view: ObjectivesViewEnum) => {
  const { data: categoryEligibility } = useGetCategoryEligibility();
  const canViewReporteeObjectives = !!categoryEligibility?.canCreateTeamObjective;

  const isTeamView = view === ObjectivesViewEnum.TEAM && canViewReporteeObjectives;

  const { data: myObjectives, isLoading: isLoadingMyObjectives } = useGetAllObjectives();
  const { data: reporteeObjectives, isLoading: isLoadingReporteeObjectives } =
    useGetReporteeObjectives(isTeamView);

  return {
    canViewReporteeObjectives,
    isTeamView,
    objectives: isTeamView ? reporteeObjectives : myObjectives,
    isLoading: isTeamView ? isLoadingReporteeObjectives : isLoadingMyObjectives,
  };
};
